import * as React from "react";
const SvgTurnOnOff = (props) => /* @__PURE__ */ React.createElement("svg", { id: "b", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 53 53", height: "1em", ...props }, /* @__PURE__ */ React.createElement("path", { id: "c", d: "M26.48,30.11V1.24M8.86,8.46c-9.97,9.74-10.15,25.73-.41,35.7,9.74,9.97,25.73,10.15,35.7.41,9.97-9.74,10.15-25.73.41-35.7-.13-.14-.27-.27-.41-.41", style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "2.5px"
} }));
export default SvgTurnOnOff;
